﻿{
  "community": {
    "name": "Community",
    "shortDescription": "Én enkelt konto med gratis aktiviteter",
    "features": [
      "Finn og del aktiviteter",
      "Ubegrenset skylagring av aktiviteter",
      "Tilgang til premiumaktiviteter"
    ],
    "price": "Gratis",
    "termName": "Evigvarende"
  },
  "personal": {
    "name": "Personlig abonnement",
    "shortDescription": "Én enkelt konto med egendefinerte aktiviteter",
    "features": [
      "Opprett og rediger aktiviteter på nett",
      "Inkluderer personlig spilleliste",
      "Tilgang til aktiviteter på farten"
    ]
  },
  "professional": {
    "name": "Profesjonelt abonnement",
    "shortDescription": "Én enkelt konto med flere elever",
    "features": [
      "Administrer elevoppgaver",
      "Følg med på elevenes fremgang",
      "Samarbeid med teammedlemmer"
    ]
  },
  "organization": {
    "name": "Organisasjonsabonnement",
    "shortDescription": "Flere kontoer med flere elever",
    "features": [
      "Instruktørledelse",
      "Rapportering på organisasjonsnivå",
      "Personvernsinnstillinger på organisasjonsnivå"
    ],
    "price": "Kontakt oss",
    "termName": "1–5-års terminer  "
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Forhåndsvisning av skrivebordsredigering",
    "note": "Prøv det <1>$t(common:action.free)</1> i 30 dager!",
    "price": "Gratis",
    "termName": "30-dagers prøveperiode",
    "footerNote": "1 installering"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Komplett skrivebordsredigering",
    "note": "",
    "termName": "Engangskjøp",
    "footerNote": "2 installeringer per bruker"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Flere lisenser for organisasjoner",
    "note": "",
    "price": "Kontakt oss",
    "termName": "Volumrabatt",
    "footerNote": "2 installeringer per bruker"
  }
}
